var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-header',{staticClass:"py-5",attrs:{"type":"gradient-success"}}),_c('div',{staticClass:"container-fluid",staticStyle:{"margin-top":"2rem"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }